import React from 'react';
import usePageComponents from '../../../hooks/usePageComponents';

const SpecsSelected = options => {
    const { label } = options || {};
    const { baseConfig } = usePageComponents(['baseConfig']);
    if (!baseConfig?.specCategories) {
        return [];
    }
    const list = baseConfig.specCategories.reduce((r, cat) => {
        const { optionitems, display, path } = cat;
        const isVisible =
            path && baseConfig.tabs && baseConfig.tabs.length > 0 ? baseConfig.tabs.includes(path) : display === 'true';

        return r.concat(
            isVisible
                ? optionitems.reduce((s, o) => {
                      if (o.selected === 'true' && o.name) {
                          if (label) {
                              s.push({ label: cat.title, value: o.name });
                          } else {
                              s.push(o.name);
                          }
                      }

                      return s;
                  }, [])
                : [],
        );
    }, []);

    return list;
};

export default SpecsSelected;
